import { ThemeConfig } from 'antd';
import variables from './variables';

const config: ThemeConfig = {
  token: {
    fontFamily: variables.fontFamily,
    colorText: variables.colorTextPrimary,
    colorTextPlaceholder: variables.colorTextSecondary,
    colorPrimary: variables.colorPrimaryMain,
    colorLink: variables.colorTextLink,
    colorError: variables.colorErrorMain,
    colorErrorBg: variables.colorErrorLight,
    colorSuccess: variables.colorSuccessMain,
    colorSuccessBg: variables.colorSuccessLight,
    colorInfo: variables.colorInfoMain,
    colorInfoBg: variables.colorInfoLight,
  },
  components: {
    Layout: {
      bodyBg: variables.colorBackgroundDefault,
      siderBg: variables.colorBackgroundDefault,
      headerBg: variables.colorBackgroundDefault,
      footerBg: variables.colorBackgroundDefault,
    },
    Button: {
      controlHeight: 40,
      borderRadius: 8,
      contentFontSize: 16,
      contentLineHeight: 1.4,
      fontWeight: 600,
      paddingInline: 12,
      paddingBlock: 8,
      opacityLoading: 1,
      defaultBorderColor: variables.colorPrimaryMain,
      defaultColor: variables.colorPrimaryMain,
      colorText: variables.colorPrimaryMain,
      colorLinkHover: variables.colorTextLink,
      lineWidth: 2,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Input: {
      /* 9 + 22 (the 14px/1.5714 line box) + 9 + 2px border = the 42px control height. The same
         three tokens are set on InputNumber and DatePicker, which share antd's input token. */
      controlHeight: 42,
      colorBorder: variables.colorBorderDark,
      borderRadius: 8,
      paddingBlock: 9,
      paddingInline: 12,
      inputFontSize: 14,
    },
    InputNumber: {
      controlHeight: 42,
      colorBorder: variables.colorBorderDark,
      borderRadius: 8,
      paddingBlock: 9,
      paddingInline: 12,
      inputFontSize: 14,
    },
    Select: {
      controlHeight: 42,
      colorBorder: variables.colorBorderDark,
      borderRadius: 8,
      fontSize: 14,
      /* Select does not extend antd's shared input token, so `paddingInline` / `inputFontSize`
         do not exist here. antd derives the selector's inline padding as `paddingSM - lineWidth`
         (antd/es/select/style/index.js:240), so 13 lands the same 12px the other controls get
         from `paddingInline` — and it positions the arrow 12px from the edge too. */
      paddingSM: 13,
    },
    Divider: {
      colorSplit: variables.colorBorderMain,
    },
    Drawer: {
      marginSM: 0,
      padding: 12,
      paddingLG: 12,
      lineWidth: 0,
    },
    Card: {
      paddingLG: 0,
      borderRadiusLG: 12,
    },
    Popover: {
      sizePopupArrow: 0,
      borderRadius: 12,
      borderRadiusLG: 12,
    },
    Menu: {
      activeBarBorderWidth: 0,
      padding: 0,
      subMenuItemBg: 'transparent',
      itemColor: variables.colorTextPrimary,
      itemHoverColor: variables.colorTextPrimary,
      itemHoverBg: variables.colorPrimaryLight,
      itemMarginBlock: 0,
      itemMarginInline: 0,
      itemHeight: 42,
      itemSelectedBg: variables.colorPrimaryLight,
      itemSelectedColor: variables.colorPrimaryDark,
    },
    DatePicker: {
      controlHeight: 42,
      colorBorder: variables.colorBorderDark,
      borderRadius: 8,
      paddingBlock: 9,
      paddingInline: 12,
      inputFontSize: 14,
    },
    Carousel: {
      arrowOffset: -16,
    },
    Radio: {
      radioSize: 24,
      dotSize: 9,
      buttonCheckedBg: variables.colorPrimaryMain,
    },
    Checkbox: {
      colorBorder: variables.colorTextDisabled,
      borderRadiusSM: 2,
      lineWidth: 1,
    },
  },
};

export default config;
